import { Component, OnInit } from "@angular/core";
import { ICustomViewComponent } from "@tylertech/custom-view";
import { AccountDetailViewModel, IInfoCardData } from "@tylertech/tyler-api-types";

@Component({
    selector: "project-account-header-card",
    templateUrl: "./header.card.tmpl.html",
    standalone: false
})
export class ProjectAccountHeaderCardComponent implements OnInit, ICustomViewComponent<IInfoCardData>
{
    readonly customDataBinding: IInfoCardData;

    private get id(): string { return this.customDataBinding?.Id; }
    private get item(): IInfoCardData { return this.customDataBinding; }

    accountIsEmpty: boolean = false;
    accountModel: unknown;
    detail: AccountDetailViewModel;
    init: boolean;
    overBudget: boolean;

    ngOnInit(): void
    {
        this.detail = this.item.DataElements.find(x => x.Name === "Detail")?.Value as AccountDetailViewModel;
        this.overBudget = this.item.DataElements.find(x => x.Name === "OverBudget")?.Value as boolean;

        this.accountModel = {
            Details: <AccountDetailViewModel>this.detail
        };

        this.accountIsEmpty = this.detail.Activity === 0
            && this.detail.CurrentBudget === 0
            && (this.detail.Encumbrance || 0) === 0
            && this.detail.Pending === 0
            && this.detail.BudgetAvailable === 0
            && (this.detail.Reserves || 0) === 0;

        this.init = true;
    }

    public getCanvasClass(): string
    {
        return `pa-search-header-card-${this.id}`;
    }
}
